import * as NavigationMenu from '@mcdougald/ui/src';
import { Typography } from '@mcdougald/ui/src';
import {
  BriefcaseIcon,
  CodeIcon,
  PersonStandingIcon,
  SpeechIcon,
} from 'lucide-react';
import Link from 'next/link';

import { ContentGridLink } from '@/components/layout/navbar/content-grid-link';
import { type NavigationItemProps } from '@/components/layout/navbar/types';
import { HOME_SECTION_IDS } from '@/constants/routing';
import { cn } from '@/libraries/tailwind/cn';
import { NAVIGATION_MENU_BG_CLASS } from '@/components/layout/navbar/constants';

/**
 * Links should route back to home
 */
export const HEADER_HOME_SUB_LINKS = [
  {
    id: 'AboutMe',
    href: `/#${HOME_SECTION_IDS.about}`,
    title: 'About Me',
    subtitle: 'Scroll to my personal information',
    icon: PersonStandingIcon,
  },
  {
    id: 'References',
    href: '/#references',
    title: 'References',
    subtitle: 'Testimonials & references from colleagues / customers',
    icon: SpeechIcon,
  },
  {
    id: 'Experience',
    href: '/#experience',
    title: 'Work Experience',
    subtitle: 'Details on my industry SWE experience',
    icon: BriefcaseIcon,
  },
  {
    id: 'Projects',
    href: '/#projects',
    title: 'Projects',
    subtitle: "See an overview of what I'm working on in spare time",
    icon: CodeIcon,
  },
  // {
  //   id: 'courses',
  //   href: '/#courses',
  //   title: 'Courses & Certifications',
  //   subtitle: 'See an overview of my courses & certifications',
  //   icon: SchoolIcon,
  // },
];
export const HomeNavigationMenuItem = ({ isActive }: NavigationItemProps) => {
  return (
    <NavigationMenu.Item
      className={cn('rounded-sm py-2 text-sm font-medium transition-colors', {
        'text-muted-foreground hover:text-gray-700': !isActive,
        'text-gray-900 underline': isActive,
      })}
    >
      <NavigationMenu.Trigger className={'cursor-pointer'}>
        <Link href={'/'}>Home</Link>
      </NavigationMenu.Trigger>
      <NavigationMenu.Content
        className={`mx-1 mt-5 absolute rounded-2xl ${NAVIGATION_MENU_BG_CLASS} p-3`}
      >
        <Typography
          variant={'xs'}
          className={'absolute top-1 left-9 bg-[#E8E9EB] text-[#bbbbbb] px-2'}
        >
          On Page
        </Typography>
        <ul className="flex flex-col gap-1 w-auto p-2 md:grid-cols-[.75fr_auto] border-1 border-[#dedcdc] rounded-lg">
          {HEADER_HOME_SUB_LINKS.map((link) => (
            <ContentGridLink key={link.href} {...link} />
          ))}
        </ul>
      </NavigationMenu.Content>
    </NavigationMenu.Item>
  );
};
